<template>
  <router-view />
</template>

<script></script>

<style>
  @import './assets/css/main.css';
</style>
